jQuery(document).ready(function($) {

	if(typeof(UIkit) === "function"){
		function ttcBuildModal() {
			const termModal = document.createElement('div');
			const termModalInner = document.createElement('div');
			const termModalContent = document.createElement('div');
			const termModalTitle = document.createElement('h2');
			const termModalCloseButton = document.createElement('button');
			const termModalNextButton = document.createElement('button');
			const termModalPrevButton = document.createElement('button');
			const termModalCTADiv = document.createElement('div');

			termModal.id = "ttcTermModal";
			termModalInner.classList.add("uk-modal-dialog", "uk-modal-body", "uk-margin-auto-vertical");
			termModalContent.classList.add("content");
			termModalTitle.classList.add("uk-modal-title");
			// termModalCloseButton.classList.add("uk-text-right", "modal-buttons");
			termModalCloseButton.innerHTML = "X";
			termModalCloseButton.classList.add("slider-button", "uk-modal-close");
			termModalNextButton.innerHTML = "<svg width=\"14\" height=\"24\" viewBox=\"0 0 14 24\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" points=\"12.775,1 1.225,12 12.775,23 \"></polyline></svg>";
			termModalNextButton.type = "button";
			termModalNextButton.classList.add("slider-button", "slider-next-button");
			termModalNextButton.addEventListener("click", function (evt) {
				let toTrigger;
				if (lastClicked.parentElement.nextElementSibling && lastClicked.parentElement.nextElementSibling.getElementsByClassName("TermTabbedPostTrigger")) {
					toTrigger = lastClicked.parentElement.nextElementSibling
				} else {
					toTrigger = lastClicked.parentElement.parentElement.firstElementChild
				}
				toTrigger.getElementsByClassName("TermTabbedPostTrigger")[0].click();
			});

			termModalPrevButton.innerHTML = "<svg width=\"14\" height=\"24\" viewBox=\"0 0 14 24\" xmlns=\"http://www.w3.org/2000/svg\"><polyline fill=\"none\" stroke=\"#000\" stroke-width=\"1.4\" points=\"12.775,1 1.225,12 12.775,23 \"></polyline></svg>";
			termModalPrevButton.type = "button";
			termModalPrevButton.classList.add("slider-button", "slider-prev-button");
			termModalPrevButton.addEventListener("click", function (evt) {
				let toTrigger;
				if (lastClicked.parentElement.previousElementSibling && lastClicked.parentElement.previousElementSibling.getElementsByClassName("TermTabbedPostTrigger")) {
					toTrigger = lastClicked.parentElement.previousElementSibling
				} else {
					toTrigger = lastClicked.parentElement.parentElement.lastElementChild
				}
				toTrigger.getElementsByClassName("TermTabbedPostTrigger")[0].click();
			});
			// termModalCloseButton.appendChild(termModalNextButton);
			termModalCTADiv.id = "ttc-term-modal-cta"
			// termModalCTADiv.classList.add("ttc-term-modal-cta");
			termModalInner.appendChild(termModalCTADiv);
			termModalInner.appendChild(termModalTitle)
			termModalInner.appendChild(termModalContent)
			termModalInner.appendChild(termModalCloseButton)
			termModalInner.appendChild(termModalNextButton)
			termModalInner.appendChild(termModalPrevButton)
			termModal.appendChild(termModalInner);
			document.body.appendChild(termModal);
			return {termModal, termModalContent};
		}

		const {termModal, termModalContent} = ttcBuildModal();

		let lastClicked;
		let loadedContent = {};
		const UIKitModal = UIkit.modal(termModal, {});

		UIKitModal.$el.addEventListener("shown", function(evt){
			//set height again
			updateModalContent();
		});

		function loadPostContent(pid, cid){

			if(loadedContent[cid+pid]){

				updateModalContent(loadedContent[cid+pid]);

			}else{

				fetch(ttcterm.url ,{
					method: 'POST', // or 'PUT'
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
					body: new URLSearchParams({
						action  : 'ttcterm_get_tabbed_post_exceprt',
						_wpnonce:ttcterm._wpnonce,
						pid:pid,
						cid:cid
					}).toString(),
				})
					.then(response => response.json())
					.then(response => {
						loadedContent[pid] = response;
						updateModalContent(response);
					})
			}


		}

		function updateModalContent(innerHtml){

			if(innerHtml){
				termModalContent.innerHTML = innerHtml;
			}

			termModalContent.style.height = termModalContent.scrollHeight.toString()+"px";

		}

		$(".wp-block-create-block-ttcterm")
			.on("click", ".TermTabbedPostTitle", function(evt){
				const childElTrigger = evt.target.getElementsByClassName("TermTabbedPostTrigger");
				if (childElTrigger.length) {
					childElTrigger[0].click()
				}
			})
			.on("click", ".TermTabbedPostTrigger", function(evt){
				const {target} = evt;
				const pid = target.dataset.postId;
				const cid = target.dataset.catId;
				lastClicked = target;
				updateModalContent("<i class='fa fa-spinner fa-spin fa-3x fa-fw'></i>")
				loadPostContent(pid, cid);

				if(!UIKitModal.isToggled()){
					UIKitModal.show();
				}
			})
	}


})
